<template>
    <div id="content">
        <div class="container">
            <div class="terms" v-html="coreParams.terms_conditions"></div>
        </div>
        <powered-by v-if="hasPoweredBy"/>
    </div>
</template>

<script>
  import PoweredBy from '../components/PoweredBy.vue';

  export default {
    components: {
      PoweredBy,
    },
  };
</script>